export default import.meta.ROLLDOWN_FILE_URL_pADEGV0e5Qot5ZhzD_GrLg